import { markInvoiceAsSent, markProjectAsSentToQuickbooks } from "@/api/invoices";
import { Divider } from "@/components/misc";
import { useState, useEffect } from "react";
import { CardDropdownInvoice } from "./Utils/CardDropdown";
import { CardBase, ColorStatus } from "./Utils/CardHelper";
import { NotesSection } from "../ProjectProgress/Utils/NotesSection";
import { InvoiceProps } from "@/interfaces/invoices_types";
import { useNavigate, useLocation } from "react-router-dom";
type InvoiceCardProps = {
    invoice: InvoiceProps,
    isNew: boolean,
    onView: () => void
}

export function InvoiceCard({ invoice, isNew, onView }: InvoiceCardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew);
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }
    }, [isNewLocal, onView]);

    const handleMark = async () => {
        if (confirm("Are you sure you want to mark this invoice as sent?")) {
            if (invoice.invoice_id) {
                const response = await markInvoiceAsSent(invoice.invoice_id);
                if (response.operation === "COMPLETED") {
                    navigate(location.pathname, { replace: true })
                }
            } else {
                alert("Invoice ID is not defined");
            }
        }
    };

    const handleMarkSentToQuickbooks = async () => {
        if (confirm("Are you sure you want to mark this invoice as sent to Quickbooks?")) {
            if (invoice.project) {
                const response = await markProjectAsSentToQuickbooks(invoice.project);
                if (response.operation === "COMPLETED") {
                    navigate(location.pathname, { replace: true })
                }
            } else {
                alert("Project ID is not defined");
            }
        }
    };

    return (
        <CardBase
            isNew={isNewLocal}
            hoverChildren={<CardDropdownInvoice
                edit_invoice_route={`/invoices/update_invoice/${invoice.invoice_id}`}
                mark_as_sent_fn={handleMark}
                mark_as_sent_to_quickbooks_fn={handleMarkSentToQuickbooks} />}
        >
            <h3>{invoice.project_name ?? 'Project Name Not Found'}</h3>

            <Divider />

            <NotesSection notes={invoice.notes ?? ''} />

            <p>Project ID: {invoice.project}</p>
            <p>Percentage Paid: {invoice.payment_amount}%</p>
            <p>Sent by: {invoice.user_sent_by_name}</p>
            <p>Date:{invoice.invoice_date}</p>
            <p className={ColorStatus(invoice.payment_status)}>{invoice.payment_status}</p>
        </CardBase>
    );
}
